
import React from "react";
import "../css-coding/AboutUsPage.css";

const AboutUsPage = () => {
  const heading = "About The Growth Secret Media";
  const missionStatement = "Where Growth Meets Success - Frame by frame, we build your name!";

  const paragraph1 =
    "The Growth Secret Media was born from a simple yet powerful vision: to bridge the gap between creativity and technology through exceptional video editing and content creation services. Founded in 2025 in the vibrant city of Coimbatore, Tamil Nadu, our journey began when two passionate individuals recognized the growing need for high-quality video content in the digital age.";

  const paragraph2 =
    "What started as a freelance collaboration between two creative minds has evolved into a full-fledged MSME-registered company that serves clients across India and beyond. Our story is one of determination, creativity, and the relentless pursuit of excellence in everything we do.";

  const getParagraph1 = () => {
    const phraseToBold = "to bridge the gap between creativity and technology";
    const highlightedText = paragraph1.replace(
      phraseToBold,
      `<strong class="highlight">${phraseToBold}</strong>`
    );
    return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />;
  };

  return (
    <div className="ags-container">
      
      <header className="ags-header">
        <p className="ags-badge">ABOUT US</p>
        <h1 className="ags-heading">{heading}</h1>
        <p className="ags-mission">{missionStatement}</p>
      </header>

      {/* Body Section */}
      <section className="ags-body">
        <p className="ags-founding-text">{getParagraph1()}</p>
        <p className="ags-founding-text">{paragraph2}</p>
      </section>
    </div>
  );
};

export default AboutUsPage;
